var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.showHomecheckCompletedStage)?_c('HomecheckCompletedStage'):(_vm.showHomecheckSentStage)?_c('HomecheckSentStage',{staticClass:"stage"}):_c('HomecheckNotSentStage',{staticClass:"stage"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }